module.exports = __webpack_public_path__ + "images/b095e8742e99734eda92af7a6acca226.smile.png";